var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "is-loading"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('div', [_vm.dateType == 'limited' ? [_c('div', {
    staticClass: "dynamic-select"
  }, [_c('b-form-select', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.datetime,
      callback: function callback($$v) {
        _vm.datetime = $$v;
      },
      expression: "datetime"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._l(_vm.dateOptions, function (timeOption, optIdx) {
    return _c('b-form-select-option', {
      key: 'date-opt-' + optIdx + '-' + (timeOption.value || ''),
      attrs: {
        "value": timeOption.value,
        "disabled": _vm.optionDisabler(timeOption.value)
      }
    }, [_vm._v(" " + _vm._s(_vm.dateOptionDisplayLabel(timeOption)) + " ")]);
  })], 2)], 1)] : _c('AppDatePicker', {
    attrs: {
      "hasError": _vm.hasError,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.datetime,
      callback: function callback($$v) {
        _vm.datetime = $$v;
      },
      expression: "datetime"
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }